module.exports = __webpack_public_path__ + "img/blogs_icon.9b658b0d.svg";